<script>
import '@/assets/css/moj.css'

export default {
  name: 'mojHeader',
}
</script>

<template>
  <div class="moj">
    <router-link to="/moj">
      <div class="logo_wrap">
        <img src="@/assets/img/moj/moj_logo.png" />
      </div>
      <img src="@/assets/img/moj/moj_banner_251119.png" />
    </router-link>
  </div>
</template>